import React, {Component} from 'react'
import { Upload, Modal, message, Button, Progress} from 'antd'
import {getuploadfileparams,selectPicDetail, removepic} from "../../servers/menu";
import {getStorage} from "../../utils";
import _ from 'lodash'
import './upload.scss'
import upload from '@/assets/images/upload.png'
import Axios from "axios";
const axios = Axios.create();

class CUpload extends Component{

  constructor(props) {
    super(props);
    this.beforeUpload = this.beforeUpload.bind(this);
    this.modalCancel = this.modalCancel.bind(this);
    this.removeFile = this.removeFile.bind(this);
    this.onChange = this.onChange.bind(this);
    this.downloads = this.downloads.bind(this)
  }


  state = {
    uploads: {
      accept: '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.jpg,.jpeg,.png,.gif,.PDF,.DOC,.DOCX,.XLS,.XLSX,.PPT,.PPTX,.JPG,.PNG,.JPEG,.GIF',
      disabled: false,
      name: 'file',
      showUploadList: false,
      defaultFileList: [],//{uid: '', name: '', url: ''}
      fileList: [],
      limit: 20,//限制上传数量 默认无限制
      size: 1024*1024*30,//默认限制大小为2M
    },
    uploadparams:{},
    open:false,
    uid:'',
    progress:0,
    upload: false,
    picdetail: {}
  };

  // 初始化upload选项
  initUploadState(data){
    if(!data){
      return
    }
    const {fileList, ...props} = _.cloneDeep(data);
    if(!fileList || !_.isArray(fileList)){
      return
    }
    fileList.forEach(item=>{
      if(item.hasOwnProperty('catcode')){
        item.uid = item.fileid.toString();
        item.status = 'done';
        item.thumbUrl = item.fileurl;
        item.name = item.filename
      }
    });
    this.setState({
      uploads: {...this.state.uploads,  ...props, fileList},
    })
  }

  getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

  // 点击modal打开
  async handlePreview(file){
    const params = {
      fileid: file.fileid
    }
    let timer = null
    selectPicDetail(params).then(res=>{
      if (res.statecode === 0 && res.records[0].filepreviewurl !== '' && res.records[0].filepreviewurl !== null) {
          const type = res.records[0].filename.split('.')[res.records[0].filename.split('.').length - 1]
          clearTimeout(timer)
          if (type === 'png' || type === 'jpg' || type === 'jpeg' || type === 'gif' || type === 'bmp' ) {
            this.setState({
              previewImage: res.records[0].filepreviewurl,
              previewVisible: true,
            });
          } else {
            window.open(res.records[0].filepreviewurl, '_blank')
          }
      } else {
        timer = setTimeout(()=>{
          this.handlePreview(file)
        },1)
      }
    })
  }

  downloads(file){
    const params = {
      fileid: file.fileid
    }
    let timer = null
    selectPicDetail(params).then(res=>{
      if (res.statecode === 0 && res.records[0].fileurl !== '' && res.records[0].fileurl !== null) {
        clearTimeout(timer)
        window.location.href = res.records[0].fileurl
      } else {
        timer = setTimeout(()=>{
          this.handlePreview(file)
        },1)
      }
    })
  }

  // 上传之前的判断
  async beforeUpload(file, fileList){
    let name = file.name;
    let size = file.size;
    let currentFileType = name.split('.').pop();
    let fileType = this.state.uploads.accept.split(',');
    if(this.state.uploads.size < size){
      message.info('文件大小超过最大限制');
      return false;
    }
    if(fileType.includes(`.${currentFileType}`)){
      const num = this.props.specialuploadid
      const id = sessionStorage.getItem('id_'+num)
      console.log(id);
      if (this.props.specialupload && this.props.id.includes('none') && (id===undefined || id==='' || id===null)){
        message.info('请选择类型');
        return false
      }
      let params = {}
      if (this.props.specialupload) {
        if (this.props.id.includes('none')) {
          params = {
            annual:getStorage('year'),
            annexcode: '401',
            dataid:id,
            fname:name
          }
        } else {
          const id = this.props.id.split('_')[2]
          params = {
            annual:getStorage('year'),
            annexcode: '401',
            dataid:id,
            fname:name
          }
        }
      } else {
         params = {
          annual:getStorage('year'),
          annexcode: this.props.id,
          fname:name
        }
      }
      await getuploadfileparams(params).then(res=>{
        if(res.statecode === 0) {
          this.setState({
            uploads: {...this.state.uploads, ...{action: res.records[0].host}},
            uploadparams:res.records[0]
          });
          let formdata = new FormData()
          formdata.append('name', file.name)
          formdata.append('key', this.state.uploadparams.key)
          formdata.append('policy', this.state.uploadparams.policy)
          formdata.append('OSSAccessKeyId', this.state.uploadparams.OSSAccessKeyId)
          formdata.append('success_action_status', this.state.uploadparams.success_action_status)
          formdata.append('callback', this.state.uploadparams.callback)
          formdata.append('signature', this.state.uploadparams.signature)
          formdata.append('x:refid', this.state.uploadparams['x:refid'])
          formdata.append('file', file)
          this.setState({
            upload:true
          })
          axios.post(
              this.state.uploadparams.host,
              formdata,
              {
                headers:
                    { 'Content-Type': 'multipart/form-data' },
                onUploadProgress:(progressEvent)=>{
                  let processStatu = (((progressEvent.loaded / progressEvent.total) * 100) | 0) ;
                  this.setState({
                    progress:processStatu
                  })
                }
              }
          )
              .then(res => {
                if (res.status === 200 && res.data.statecode === 0) {
                  message.success('上传成功')
                  res.data.records.forEach(item=>{
                    if(item.hasOwnProperty('catcode')){
                      item.uid = item.fileid.toString();
                      item.status = 'done';
                      item.thumbUrl = item.fileurl;
                      item.name = item.filename
                    }
                  });
                  this.setState({
                    upload:false,
                    progress: 0,
                  })
                  const uploadarr = this.state.uploads.fileList.concat(res.data.records)
                  this.setState({
                    uploads: {...this.state.uploads, ...{fileList: uploadarr}}
                  });
                } else {
                  message.error('上传失败')
                  this.setState({
                    progress:0
                  })
                }
              })
              .catch(error => {
                message.error('上传失败')
                this.setState({
                  progress:0
                })
                console.log(error)
              })
        } else {
          message.info(res.statemessage);
        }
      })
      return false;
    }else{
      message.info('请上传指定的文件类型');
    }
    return false
  }

  confirmModal = (file) => {
    const params = {
      fileid:file.fileid
    }
    removepic(params).then(res=>{
      if (res.statecode === 0) {
        message.success('移除成功')
        const data = JSON.parse(JSON.stringify(this.state.uploads.fileList))
        data.forEach((item,index)=>{
          if (file.fileid === item.fileid){
            data.splice(index,1)
          }
        })
        this.setState({
          uploads: {...this.state.uploads, ...{fileList: data}}
        });
      } else {
        message.error(res.statemessage)
      }
    })
  };

  // 移出文件
  removeFile(file){
    Modal.confirm({
      content: '确认移除该附件',
      okText: '确认',
      cancelText: '取消',
      onCancel:()=>{
        this.setState({
          uid:'',
        })
      },
      onOk:()=>{
        this.confirmModal(file)
      }
    });
  }

  // 触发上层change事件
  onChange(data){
    console.log(data);
    this.props.onChange && this.props.onChange(data);
  }

  // modal取消
  modalCancel(){
    this.setState({
      previewVisible: false
    })
  }

  componentWillReceiveProps(nextProps) {
    this.initUploadState(nextProps);
  }

  componentWillMount(){
    this.initUploadState(this.props);
  }

  componentDidMount(){

  }

  render(){
    return (
      <div className={`c-upload ${this.props.className}`}>
        {/*onPreview={(file) => this.handlePreview(file)}*/}
        <div style={{display:'flex',alignItems:'center'}}>
          <Upload
              disabled={this.state.upload}
              {...this.state.uploads}
              beforeUpload={(file, fileList) => this.beforeUpload(file, fileList)}
              onRemove={(file) => this.removeFile(file)}
          >
            {this.state.uploads.fileList.length >=20 ? null :<div><Button type='primary'><img src={upload} alt="" style={{width:'20px'}}/>请点击上传{this.props.btnname}</Button></div> }
          </Upload>
          <span style={{marginLeft:'20px',fontWeight:'bold',marginTop:'-8px'}}>{this.props.name}</span>
        </div>
        {this.state.progress>0?<Progress percent={this.state.progress}/>:''}
        <div style={{color:'#666666'}}>
          附件最多上传20个，单个附件文件不能大于30M，附件文件格式支持PDF、OFFICE和图片文件。
        </div>
        <ul className='uploadlist'>
          {
              this.state.uploads.fileList.length>0?
              this.state.uploads.fileList.map((item,index)=>{
               return <li>
                 <span>{index+1}.{item.filename}</span>
                 <div>
                   <span className="textbtn" onClick={()=>{this.removeFile(item)}}>删除</span>
                   <span className="textbtn" onClick={()=>{this.downloads(item)}}>下载</span>
                   <span className="textbtn" onClick={()=>{this.handlePreview(item)}}>预览</span>
                 </div>
               </li>
            }):''
          }
        </ul>
        <Modal visible={this.state.previewVisible} footer={null} onCancel={this.modalCancel}>
          <div style={{width:'100%',height:'400px',display:'flex',justifyContent:'center',alignItems:'center'}}>
            <img alt="example" style={{ maxWidth: '400px' }} src={this.state.previewImage} />
          </div>
        </Modal>
      </div>
    )
  }
}

CUpload.defaultProps = {

}

CUpload.propTypes = {

}

export default CUpload
